import styled from 'styled-components';

export const StyledH3 = styled.h3`
    color: ${(props) => props.theme.font.highlightColor};
`;
